import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
    detallesAreaConfiguracion,
    editarAreaConfiguracion
} from '../../../actions/configuracion';

const EditarArea = ({ area, reestablecerArea }) => {

    const dispatch = useDispatch();
    const { detalle } = useSelector(state => state.configuracion.areas);

    const [show, setShow] = useState(false);
    const [nombre, setNombre] = useState('');

    // Cuando llega un área para editar, abrimos modal y pedimos detalle
    useEffect(() => {
        if (area && area._id) {
            setShow(true);
            dispatch(detallesAreaConfiguracion(area._id));
        } else {
            setShow(false);
        }
    }, [area, dispatch]);

    // Cuando el backend responde con el detalle, llenamos el input
    useEffect(() => {
        if (detalle && area && detalle._id === area._id) {
            setNombre(detalle.nombre || '');
        }
    }, [detalle, area]);

    const handleClose = () => {
        setShow(false);
        setNombre('');
        reestablecerArea(null); // resetea el state en Areas.js
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!nombre.trim()) return;

        const resp = await dispatch(
            editarAreaConfiguracion({
                id: area._id,
                nombre: nombre.trim()
            })
        );

        if (resp && resp.success) {
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <form onSubmit={handleSubmit}>
                <div className="modal-header">
                    <h5 className="modal-title">Editar área</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                        aria-label="Close"
                    ></button>
                </div>

                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label">Nombre</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre del área"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleClose}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Guardar cambios
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default EditarArea;
